function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M96.6 117.39l-4.4 46.51L4 170.81q.63-36.56 1.41-72.7t1.94-72.69h54.47q-2.41 22.94-4.61 45.83t-3.14 46.14q4.92.21 9.74.21h9.74q5.86 0 11.52-.11c3.78-.07 7.61-.1 11.53-.1z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M196 27.31l-1 44.41L163.74 73l-8 99.3-44.2 2.3.2-99.3L80.57 77l1.26-49.44z"
});

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), _ref, _ref2);
}

export default SvgLogo;